export class GetRanking {
  static readonly type = '[Gamification] - Get Ranking';
}

export class GetBadges {
  static readonly type = '[Gamification] - Get Badges';
}

export class GetMonthlyScore {
  static readonly type = '[Gamification] - Get Monthly Score';
}

export class GetGeneralScore {
  static readonly type = '[Gamification] - Get General Score';
}

export class SetLoadingState {
  static readonly type = '[Gamification] - Set Loading State';
  constructor(public readonly isLoading: boolean) {}
}
